import axios from "axios";

export default axios.create({
 baseURL: process.env.REACT_APP_API_ADMIN_PORTAL_BASE_URL_POC,
  headers: {
    "Content-type": "application/json"
  }
});
